import type { HTMLAttributes } from "react";

export default function NotificationsUnreadUnseenCountPositioner({ children }: HTMLAttributes<HTMLDivElement>) {
  return <div className="absolute left-[60%] top-[-40%] box-border appearance-none">{children}</div>;
}
